<template>
  <div>
    <v-container fluid>
        <material-card icon="mdi-clipboard-text" inline title="Dummy Notification Trigger">
            <v-card-actions>
            <router-link slot="right" :to="{ name: 'notficationTrigger' }">
                <v-btn
                elevation="1"
                absolute
                right
                top
                >
                <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
            </router-link>
            </v-card-actions>
            <v-card flat class="px-2">
            <v-row>
                <v-col  cols="12" md="3" sm="4" class="pl-6 pr-6">
                    <v-list-item class="my-6" tile>
                    <v-autocomplete
                        key="id"
                        label="Select ModuleName"
                        :items="moduleNames"
                        v-model="selectedModuleName"
                        @change="checkModuleImage"
                        required
                        item-text="name"
                        item-value="name"
                        :hide-details="true"
                    >
                    </v-autocomplete>
                    </v-list-item>
                </v-col>
                <v-col  cols="12" md="3" sm="4" class="pl-6 pr-6">
                    <v-list-item class="my-6" tile>
                    <v-autocomplete
                        key="name"
                        label="Select UserType"
                        :items="usertype"
                        v-model="selectedUsertype"
                        @change="onUserTypeChange"
                        required
                        item-text="name"
                        item-value="name"
                        :hide-details="true"
                    >
                    </v-autocomplete>
                    </v-list-item>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="text-center mb-4">
                    <v-text-field
                      v-model="title"
                      label="Notification Title"
                      required
                      class="mb-4"
                    />
                    <v-text-field
                      v-model="body"
                      label="Notification Description"
                      required
                      class="mb-4"
                    />
                    <v-text-field
                      v-if="!pageURLAvailable"
                      v-model="moduleURL"
                      label="Module URL"
                      class="mb-4"
                      />
                          <v-alert
                            v-if="!pageURLAvailable"
                            type="info"
                            dense
                            outlined
                            class="mb-4"
                          >
                            Note: Add <strong>ref=notif_push_&lt;value&gt;</strong> at the end of the Module URL when providing a ref value.
                          </v-alert>
                    <v-alert v-if="pageURLAvailable" type="info" dense text class="mb-4">
                      Page URL is available in constants
                    </v-alert>
                    <v-text-field
                      v-if="!moduleImageAvailable"
                      v-model="imageURL"
                      label="Notification image URL"
                      class="mb-4"
                    />
                    <v-alert v-if="moduleImageAvailable" type="info" dense text class="mb-4">
                      Module image is available in constants
                    </v-alert>
                    <v-text-field
                      v-if="pageURLAvailable"
                      v-model="refParameter"
                      label="Ref Parameter"
                      class="mb-4"
                      />
                         <v-alert
                          v-if="pageURLAvailable"
                          type="info"
                          dense
                          outlined
                          class="mb-4"
                          >
                          Please begin the parameter with <strong>notif_push_</strong> before adding the value.
                          </v-alert>
                    <v-radio-group v-if="selectedUsertype !== 'NON-REGISTERED'" v-model="referenceType" row>
                      <v-radio label="Mobile Number" value="number"></v-radio>
                      <v-radio label="User ID" value="userId"></v-radio>
                    </v-radio-group>
                    <div v-if="(selectedUsertype === 'NON-REGISTERED' && referenceType === 'userId')" class="mb-4">
                      <v-text-field
                        v-model="referenceId"
                        label="Enter adv_ID"
                        required
                      />
                    </div>
                    <div v-else-if="referenceType === 'number' " class="mb-4">
                      <v-text-field
                        v-model="referenceNumber"
                        label="Enter Mobile Number"
                        required
                        type="number"
                        :rules="[
                          v => !!v || 'Number is required',
                          v => /^\d+$/.test(v) || 'Only numbers are allowed'
                        ]"
                      />
                    </div>
                    <div v-else-if="referenceType === 'userId' && selectedUsertype !== 'NON-REGISTERED' " class="mb-4">
                      <v-text-field
                        v-model="referenceUserId"
                        label="Enter User ID"
                        required
                      />
                    </div>
                    <v-btn color="primary" @click="triggerDummyNotification">Trigger Notification</v-btn>
                </v-col>
            </v-row>
            </v-card>
        </material-card>
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'dummyNotificationTrigger',
  components: { MaterialCard },
  data () {
    return {
      moduleNames: [
        // { id: 1, name: 'ReportCardStack' },
        // { id: 2, name: 'GallaryStack' },
        // { id: 3, name: 'ClassDiaryStack' },
        // { id: 4, name: 'Child_Details' },
        // { id: 5, name: 'OnlineClassStack' },
        // { id: 6, name: 'EventCalendarStack' },
        // { id: 7, name: 'MyHomeworkStack' },
        // { id: 8, name: 'FeeDetailsStack' },
        // { id: 9, name: 'AnnouncementsStack' },
        // { id: 10, name: 'communicationAnnouncementsStack' },
        // { id: 11, name: 'personalMessageStack' },
        { id: 12, name: 'WorkSheetStack' },
        // { id: 13, name: 'SummerCampStack' },
        { id: 14, name: 'IntelliSkillsBooksStack' },
        { id: 15, name: 'RewardsStack' },
        { id: 16, name: 'EduMagStack' },
        { id: 17, name: 'PreschoolLocatorStack' },
        { id: 18, name: 'ShopStack' },
        { id: 19, name: 'IntelliSkillsToysStack' },
        // { id: 20, name: 'MyPreschoolModulesStack' },
        { id: 21, name: 'IntelliBabyStack' },
        { id: 22, name: 'IntellitotsStack' },
        // { id: 23, name: 'DaycareStack' },
        { id: 24, name: 'EventsStack' },
        { id: 25, name: 'RadioStack' }
      ],
      selectedModuleName: null,
      usertype: [
        { name: 'ENROLLED' },
        { name: 'REGISTERED' },
        { name: 'NON-REGISTERED' }
      ],
      selectedUsertype: null,
      title: null,
      body: null,
      referenceType: 'number',
      referenceNumber: null,
      referenceUserId: null,
      referenceId: null,
      imageURL: null,
      moduleURL: null,
      moduleImageAvailable: false,
      pageURLAvailable: false,
      refParameter: null
    }
  },

  methods: {
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    onUserTypeChange () {
      if (this.selectedUsertype === 'NON-REGISTERED') {
        this.referenceType = 'userId'
        this.referenceNumber = null
        this.referenceId = null
      } else {
        this.referenceUserId = null
        this.referenceId = null
        this.referenceNumber = null
        this.referenceType = 'number'
      }
    },
    async checkModuleImage () {
      if (!this.selectedModuleName) {
        this.moduleImageAvailable = false
        this.pageURLAvailable = false
        return
      }

      try {
        const response = await http.get(`${constants.API_URL}/api/admin/app-notification/check-module-image`, {
          params: { moduleName: this.selectedModuleName }
        })

        this.moduleImageAvailable = response.data.isAvailable
        this.pageURLAvailable = response.data.isPageURLAvailable

        if (this.moduleImageAvailable) {
          this.imageURL = null
        }

        if (this.pageURLAvailable) {
          this.moduleURL = response.data.pageURL
          this.referenceNumber = null
          this.referenceUserId = null
        }
      } catch (err) {
        console.error('Error checking module image:', err)
        this.moduleImageAvailable = false
        this.pageURLAvailable = false
      }
    },
    async triggerDummyNotification () {
      // Helper to trim and check empty
      const isEmpty = v => !v || !v.trim()

      if (isEmpty(this.selectedModuleName)) {
        this.errMsg('Please select Module Name')
        return
      }
      if (isEmpty(this.selectedUsertype)) {
        this.errMsg('Please select User Type')
        return
      }
      if (isEmpty(this.title)) {
        this.errMsg('Please enter Notification Title')
        return
      }
      if (isEmpty(this.body)) {
        this.errMsg('Please enter Notification Description')
        return
      }
      if (!this.pageURLAvailable && isEmpty(this.moduleURL)) {
        this.errMsg('Please enter Module URL')
        return
      }
      if (this.pageURLAvailable) {
        if (isEmpty(this.refParameter)) {
          this.errMsg('Please enter Ref Parameter')
          return
        }
        if (this.moduleURL && this.refParameter) {
          if (this.moduleURL.includes('?')) {
            this.moduleURL = `${this.moduleURL}&ref=${this.refParameter.trim()}`
          } else {
            this.moduleURL = `${this.moduleURL}?ref=${this.refParameter.trim()}`
          }
        }
      }
      if (this.selectedUsertype === 'NON-REGISTERED' && isEmpty(this.referenceId)) {
        this.errMsg('Please enter adv_ID')
        return
      }
      if (this.selectedUsertype !== 'NON-REGISTERED') {
        if (this.referenceType === 'number' && isEmpty(this.referenceNumber)) {
          this.errMsg('Please enter Reference Number')
          return
        }
        if (this.referenceType === 'userId' && isEmpty(this.referenceUserId)) {
          this.errMsg('Please enter Reference User ID')
          return
        }
      }
      if (!this.moduleImageAvailable && isEmpty(this.imageURL)) {
        this.errMsg('Please enter Image URL')
        return
      }

      const payload = {
        userType: this.selectedUsertype && this.selectedUsertype.trim(),
        moduleName: this.selectedModuleName && this.selectedModuleName.trim(),
        moduleURL: (this.moduleURL && this.moduleURL.trim()) || '',
        title: this.title && this.title.trim(),
        body: this.body && this.body.trim()
      }

      payload.mobileNumber = this.referenceType === 'number' && this.selectedUsertype !== 'NON-REGISTERED'
        ? this.referenceNumber && this.referenceNumber.toString().trim()
        : undefined
      payload.userID = (this.referenceType === 'userId' && this.selectedUsertype !== 'NON-REGISTERED')
        ? this.referenceUserId && this.referenceUserId.trim()
        : undefined
      payload.adv_ID = this.selectedUsertype === 'NON-REGISTERED'
        ? this.referenceId && this.referenceId.trim()
        : undefined

      if (this.imageURL && !this.moduleImageAvailable) {
        payload.imageURL = this.imageURL.trim()
      }

      if (this.selectedUsertype === 'NON-REGISTERED') {
        payload.pagetype = 'NonRegisterdUserDetails'
      }

      // Prepare readable notification data for confirmation
      const notificationData = [
        { label: 'Module Name', value: payload.moduleName },
        { label: 'User Type', value: payload.userType },
        { label: 'Notification Title', value: payload.title },
        { label: 'Notification Description', value: payload.body },
        { label: 'Module URL', value: payload.moduleURL },
        { label: 'Image URL', value: payload.imageURL || (this.moduleImageAvailable ? 'Available in constants' : '') },
        { label: 'Mobile Number', value: payload.mobileNumber },
        { label: 'User ID', value: payload.userID },
        { label: 'adv_ID', value: payload.adv_ID },
        { label: 'Page Type', value: payload.pagetype }
      ].filter(item => item.value !== undefined && item.value !== '')

      // Dynamically generate HTML table for notification data
      const html = `
        <div style="max-width: 100%; overflow-x: auto;">
          <table style="width: 100%; min-width: 500px; text-align: left; border-collapse: collapse;">
        <tbody>
          ${notificationData.map(item =>
    `<tr>
          <td style="font-weight:bold;padding:4px 16px 4px 0;white-space:nowrap;">${item.label}</td>
          <td style="padding:4px 0;word-break:break-all;">${item.value}</td>
        </tr>`
  ).join('')}
        </tbody>
          </table>
        </div>
      `

      // Show confirmation popup with readable notification data
      this.$buefy.dialog.confirm({
        title: 'Confirm Notification',
        message: html,
        confirmText: 'OK',
        cancelText: 'Cancel',
        type: 'is-info',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await http.post(`${constants.API_URL}/api/admin/app-notification/dummy-notification`, payload)

            this.$buefy.toast.open({
              message: 'Dummy notification triggered successfully!',
              type: 'is-success',
              duration: 5000,
              position: 'is-top-right'
            })
            this.resetForm()
          } catch (err) {
            this.errMsg(err.response?.data?.message || 'Failed to trigger notification')
          }
        }
      })
    },
    resetForm () {
      this.selectedModuleName = null
      this.selectedUsertype = null
      this.title = null
      this.body = null
      this.referenceType = 'number'
      this.referenceNumber = null
      this.referenceUserId = null
      this.referenceId = null
      this.imageURL = null
      this.moduleURL = null
      this.moduleImageAvailable = false
      this.pageURLAvailable = false
      this.refParameter = null
    }
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.truncated-text {
    cursor: pointer;
}
</style>
